import type React from "react";

import { cn } from "../../../utils";

export const Error = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn("text-sm font-normal leading-5 text-red-500", className)}
    >
      {children}
    </div>
  );
};
